export {AvatarComponent} from './avatar.component';
